/* ==============================================
   ZERODVSN — Animations & Interactions
   zerodvsn.com
   ============================================== */
(function () {
  'use strict';

  // ------------------------------------------------
  // CUSTOM CURSOR — disabled, using default cursor
  // ------------------------------------------------
  function initCursor() {
    // Remove cursor elements if they exist
    var dot = document.getElementById('zd-cursor');
    var ring = document.getElementById('zd-cursor-ring');
    if (dot) dot.remove();
    if (ring) ring.remove();
  }

  // ------------------------------------------------
  // MAGNETIC BUTTONS
  // ------------------------------------------------
  function initMagneticButtons() {
    if (!window.matchMedia('(pointer: fine)').matches) return;

    document.querySelectorAll('.button--primary, .button--secondary').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width  / 2;
        var y = e.clientY - rect.top  - rect.height / 2;
        btn.style.transform = 'translate(' + (x * 0.16) + 'px, ' + (y * 0.16) + 'px)';
      });

      btn.addEventListener('mouseleave', function () {
        btn.style.transition = 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        btn.style.transform  = '';
        setTimeout(function () { btn.style.transition = ''; }, 450);
      });
    });
  }

  // ------------------------------------------------
  // GSAP SCROLL ANIMATIONS
  // ------------------------------------------------
  function initGSAP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    // Respect prefers-reduced-motion
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    // -- Hero: first banner heading + text fly-in on page load --
    var firstSection = document.querySelector('.shopify-section');
    if (firstSection) {
      var heroHeading = firstSection.querySelector('.image-banner__heading');
      var heroInfo    = firstSection.querySelector('.image-banner__information');
      var heroBtn     = firstSection.querySelector('.image-banner__button-wrapper');
      var heroEls     = [heroHeading, heroInfo, heroBtn].filter(Boolean);

      if (heroEls.length) {
        gsap.from(heroEls, {
          y:        55,
          opacity:  0,
          duration: 1.3,
          stagger:  0.14,
          ease:     'power3.out',
          delay:    0.15,
        });
      }
    }

    // -- Parallax on every image banner --
    document.querySelectorAll('.image-banner__img').forEach(function (banner) {
      var img = banner.querySelector('img');
      if (!img) return;
      gsap.fromTo(
        img,
        { yPercent: -10 },
        {
          yPercent: 10,
          ease: 'none',
          scrollTrigger: {
            trigger: banner,
            start:   'top bottom',
            end:     'bottom top',
            scrub:   1.2,
          },
        }
      );
    });

    // -- Section header reveals --
    document.querySelectorAll('.section-header, .section__header').forEach(function (el) {
      gsap.from(el, {
        y:        28,
        opacity:  0,
        duration: 0.85,
        ease:     'power2.out',
        scrollTrigger: {
          trigger:       el,
          start:         'top 90%',
          toggleActions: 'play none none none',
        },
      });
    });

    // -- Non-hero banner text reveals (scroll-triggered) --
    var laterBanners = document.querySelectorAll(
      '.shopify-section:not(:first-child) .image-banner__heading, ' +
      '.shopify-section:not(:first-child) .image-banner__information, ' +
      '.shopify-section:not(:first-child) .image-banner__button-wrapper'
    );
    laterBanners.forEach(function (el) {
      gsap.from(el, {
        y:        42,
        opacity:  0,
        duration: 1.1,
        ease:     'power3.out',
        scrollTrigger: {
          trigger:       el,
          start:         'top 88%',
          toggleActions: 'play none none none',
        },
      });
    });

    // -- Product card stagger reveal (batch) --
    ScrollTrigger.batch('.card-wrapper', {
      start:   'top 92%',
      once:    true,
      onEnter: function (batch) {
        gsap.from(batch, {
          y:        38,
          opacity:  0,
          duration: 0.68,
          stagger:  0.07,
          ease:     'power2.out',
          clearProps: 'all',
        });
      },
    });

    // -- Featured product section reveal --
    var featuredSection = document.querySelector(
      '.section-featured-product, [class*="featured-product"]'
    );
    if (featuredSection) {
      var children = Array.from(featuredSection.children);
      if (children.length) {
        gsap.from(children, {
          y:        30,
          opacity:  0,
          duration: 0.9,
          stagger:  0.09,
          ease:     'power2.out',
          scrollTrigger: {
            trigger:       featuredSection,
            start:         'top 86%',
            toggleActions: 'play none none none',
          },
        });
      }
    }

    // -- Refresh on Shopify editor section load --
    document.addEventListener('shopify:section:load', function () {
      ScrollTrigger.refresh();
    });
  }

  // ------------------------------------------------
  // INIT
  // ------------------------------------------------
  function init() {
    initCursor();
    initMagneticButtons();

    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      initGSAP();
    } else {
      // GSAP loads deferred — wait for window load as fallback
      window.addEventListener('load', initGSAP, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
